/** Display label for a round number (strips zero-padding from API/DB values). */
export function formatRoundDisplay(round) {
  if (round == null || round === '') return '';
  const n = parseInt(String(round), 10);
  return Number.isFinite(n) ? String(n) : String(round);
}
